/**
 * Move my points.
 * @author Dayne Coulson-Hoffacker
 */
export default class MoveMyPoints {
  /**
   * Constructs a new counter component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.mainQuestion = this.element.querySelector('#main-question')
    this.header = this.element.querySelector('header')
    this.plane = this.element.querySelector('.plane')
    this.formWrapper = this.element.querySelector('.form-wrapper')
    this.mainQuestionSelect = this.mainQuestion.querySelector('select')
    this.mainQuestionEmptySpan = this.mainQuestion.querySelector('.empty')
    this.resultQuestion = this.element.querySelector('#result-question')
    this.resultQuestionSelect = this.resultQuestion.querySelector('select')
    this.resultQuestionEmptySpan = this.resultQuestion.querySelector('.empty')
    this.resultsPanel = this.element.querySelector('.results')
    this.bankURLCta = this.resultsPanel.querySelector('.cta')
    this.steps = this.resultsPanel.queryAll('.steps li')
    this.step1 = this.steps[0].querySelector('span')
    this.step2 = this.steps[1].querySelector('span')
    this.step3 = this.steps[2].querySelector('span')
    this.step4 = this.steps[3].querySelector('span')
    this.step5 = this.steps[4].querySelector('span')
    this.step6 = this.steps[5].querySelector('span')

    // Fetch json file and populate drop down options
    const url = '/content/dam/velocity/campaign/documents/may2017/movepointssteps.json'

    let banks = []
    fetch(url, {
      credentials: 'include'
    }).then(resp => {
      return resp.json()
    })
      .then(data => {
        this.banks = data.banks.map(result => {
          return JSON.parse(result)
        })

        this.selectedBank = this.banks.find(bank => bank.bankName === this.readCookie('BankName'))

        this.createDropdown(this.mainQuestionSelect, this.banks)
        this.createDropdown(this.resultQuestionSelect, this.banks)

        this.updateBankCTAURL()
        this.updateBankSteps()

        this.resultQuestionSelect.value = this.selectedBank.bankName || this.readCookei('BankName')

      })
      .catch(error => {
        console.log(error)
      })

    // Main Question Functionality
    this.mainQuestionSelect.addEventListener('change', element => {
      this.mainQuestionEmptySpan.innerHTML = this.mainQuestionSelect.value
      this.resultQuestionEmptySpan.innerHTML = this.mainQuestionSelect.value
      this.selectedBank = this.banks.find(bank => bank.bankName === element.target.value)
      this.resultQuestionSelect.value = this.selectedBank.bankName
      this.resultQuestionEmptySpan.innerHTML = this.selectedBank.bankName

      this.updateBankCTAURL()
      this.updateBankSteps()

      setTimeout(() => {
        this.resultsPanel.classList.add('visible')
      }, 500
      )
    })

    // Result Question Functionality
    this.resultQuestionSelect.addEventListener('change', element => {
      this.selectedBank = this.banks.find(bank => bank.bankName === element.target.value)
      this.resultQuestionEmptySpan.innerHTML = this.resultQuestionSelect.value
      this.mainQuestionEmptySpan.innerHTML = this.resultQuestionSelect.value

      this.updateBankCTAURL()
      this.updateBankSteps()
    })

    // If calculatorCompleted cookie present, enable results section
    if (this.readCookie('BankName')) {
      this.resultQuestionSelect.value = this.readCookie('BankName')
      this.resultQuestionEmptySpan.innerHTML = this.readCookie('BankName')
      this.header.classList.add('hidden')
      this.plane.classList.add('hidden')
      this.formWrapper.classList.add('hidden')
      this.resultsPanel.classList.add('visible')
      this.updateBankCTAURL()
      this.updateBankSteps()
    }
  }

  // Update Bank CTA URL
  updateBankCTAURL () {
    if (this.selectedBank) {
      this.bankURLCta.setAttribute('href', this.selectedBank.bankUrl)
    }
  }

  // Update bank steps on page load and also on dropdown change.
  updateBankSteps () {
    if (this.selectedBank) {
      this.selectedBank.steps.forEach((step, index) => {
        if (index === 0) {
          this.step1.innerHTML = step.stepDescr
        } else if (index === 1) {
          this.step2.innerHTML = step.stepDescr
        } else if (index === 2) {
          this.step3.innerHTML = step.stepDescr
        } else if (index === 3) {
          this.step4.innerHTML = step.stepDescr
        } else if (index === 4) {
          this.step5.innerHTML = step.stepDescr
        } else if (index === 5) {
          this.step6.innerHTML = step.stepDescr
        }
      })
    }
  }

  createDropdown (select, banks) {
    banks.forEach(bank => {
      let option = this.createNode('option')
      option.value = `${bank.bankName}`
      option.innerHTML = `${bank.bankName}`
      this.append(select, option)
    })
  }

  // Read cookie
  readCookie (name) {
    var nameEQ = name + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length)
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length)
      }
    }
    return null
  }

  // Create node function
  createNode (element) {
    return document.createElement(element)
  }

  // Append function
  append (parent, el) {
    return parent.appendChild(el)
  }

}



// WEBPACK FOOTER //
// ./components/move-my-points/index.js